import { render } from "./OptionPage.vue?vue&type=template&id=398bc296&scoped=true"
import script from "./OptionPage.vue?vue&type=script&lang=js"
export * from "./OptionPage.vue?vue&type=script&lang=js"

import "./OptionPage.vue?vue&type=style&index=0&id=398bc296&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398bc296"]])

export default __exports__